import { Link } from "react-router-dom";
import { Anchor, Waves, Wind, Moon, ArrowRight } from "lucide-react";

export default function FishingConditionsTeaser() {
  return (
    <section className="bg-slate-950 px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[2rem] border border-cyan-400/20 bg-gradient-to-br from-cyan-500/10 via-slate-900/80 to-slate-950 p-6 sm:p-8 panel-lift">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(6,182,212,0.12),transparent_60%)]" />

          <div className="relative flex flex-wrap items-center justify-between gap-6">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan-400/15 ring-2 ring-cyan-400/30">
                <Anchor className="h-6 w-6 text-cyan-300" />
              </div>
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Sea &amp; Fishing Conditions</p>
                <h2 className="mt-1 text-2xl font-bold tracking-tight text-white sm:text-3xl">
                  Live weather, tides &amp; sea state
                </h2>
                <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-400">
                  <span className="flex items-center gap-1.5"><Waves className="h-3.5 w-3.5 text-cyan-400" /> Wave &amp; swell height</span>
                  <span className="flex items-center gap-1.5"><Wind className="h-3.5 w-3.5 text-cyan-400" /> Wind &amp; weather forecast</span>
                  <span className="flex items-center gap-1.5"><Moon className="h-3.5 w-3.5 text-cyan-400" /> Tides &amp; moon phase</span>
                </div>
              </div>
            </div>

            <Link
              to="/fishing-conditions"
              className="inline-flex shrink-0 items-center gap-2 rounded-2xl border border-cyan-500/60 bg-gradient-to-r from-cyan-500 to-sky-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-cyan-500/20 transition hover:from-cyan-400 hover:to-sky-400"
            >
              View Fishing Conditions
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
